import produce from 'immer';
import _ from 'underscore';

import {NoteLinkedFile, NoteLinkedObjectType, NotePartWithItem} from 'notebook/util/NoteUtilConstants';

import {EditorMixinInterface} from '../Editor';

export default function convertNotePartGridForPaste(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  item: any,
  component: Partial<EditorMixinInterface>
): void {
  for (let i = 0; i < item.item.containedNoteParts.length; i++) {
    const containedNotePart = item.item.containedNoteParts[i];
    const containedItem = containedNotePart.item;

    // Always regenerate the note-part cid
    const newContainedNotePartWithCid = produce(containedNotePart, (draft: {cid: string}) => {
      draft.cid = _.uniqueId('note-part');
    });

    item.item.containedNoteParts[i] = newContainedNotePartWithCid;

    // Additionally regenerate the NoteLinkedFile cid if present
    if (
      containedItem != null &&
      component.props!.getType(containedItem) === NoteLinkedObjectType.NOTE_LINKED_FILE
    ) {
      const oldItemCid = containedItem.cid;
      const serverId = component.props!.getIdFromCid(oldItemCid);
      const newItemCid = _.uniqueId('note-linked-file-');
      const newContainedNotePartWithItemCid = produce(
        newContainedNotePartWithCid,
        (draft: NotePartWithItem<NoteLinkedFile>) => {
          draft.item.cid = newItemCid;
        }
      );
      if (serverId != null) {
        component.props!.registerObjects({[newItemCid]: serverId});
      }
      item.item.containedNoteParts[i] = newContainedNotePartWithItemCid;
    }
  }
}
